import { Navigate, useLocation } from 'react-router-dom'

import { GlobalSpinner } from '@maxus/website/components'
import { useAuth } from '@maxus/website/hooks'
import { buildLoginUrl } from '@maxus/website/utils'

/**
 * 登录态门禁：未登录时导向登录页，由登录页处理具体登录方式。
 * - 飞书容器内：登录页自动走 H5 免登（见 use-feishu-silent-login），成功后跳回 returnTo。
 * - 非飞书（移动端浏览器 / 桌面 / Electron）：登录页展示手动登录（飞书网页授权）。
 *
 * 移动端浏览器「用飞书打开」的 applink 引导已上移到 App 根层（见 use-feishu-applink-prompt），
 * 不区分登录态、对所有移动端路由生效，故此处不再处理。
 */
export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'loading') return <GlobalSpinner />
  if (status === 'guest') {
    return <Navigate to={buildLoginUrl(location.pathname + location.search)} replace />
  }
  return <>{children}</>
}
